<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div :class="{ 'loading-opacity': preloader }">
      <div class="alert alert-warning" role="alert">
        Esta opción deberá ser utilizada únicamente cuando se requiera devolver un proceso
        o pasar a los siguientes estados del flujo de acreditación. 
        Será necesario ingresar la justificación respectiva para poder realizar esta acción.
      </div>
      <app-input
        type="radio-buttons"
        class="my-3"
        :list="list_return"
        v-model="is_return"
      />
      <div v-if="is_return">
        <div class="form-group mt-2">
          <label>Observaciones<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
          <app-input
            type="textarea"
            v-model="inputs.observations"
            placeholder="Ingrese la Dirección"
          />
        </div>
      
        <div class="form-group mt-2">
          <label >Devolver proceso<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
          <app-input
            id="inputs_return_process"
            class="row col-md-6"
            type="select"
            v-model="inputs.return_process"
            :list="listReturn"
            :required="true"
          />
        </div>
      </div>
      <button type="button" class="btn btn-primary mt-2" @click="openDeleteModal" v-if="is_return">
          <!-- <app-icon name="save" /> -->
          Guardar
      </button>
          
    </div>
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="modal-confirm-id"
      @confirmed="postReturnProcess"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea procesar este registro?"
      firstButtonName="Aceptar"
      secondButtonName="Cancelar"
      modalClass="success"
      icon="cpu"
    />
  </div>

</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { axiosPost } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],
  data() {
      return {
          preloader:true,
          inputs: {},
          listReturn: [],
          confirmationModalActive: false,
          is_return:0,
          list_return: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      }
  },
  created() {
    this.data();
  },
  methods: {
    data() {
      let urlAccApp = `/accreditationtechnical/return-processes/show/${this.$store.state.accreditation.id}`;
      this.axiosGet(urlAccApp).then((response) => {
        if (response.data && response.data.accreditation_type_id == 1) {
          this.listReturn = [
            { id: "", value: this.$t("select_option") },
            { id: "605", value: "Acreditación Inicial - Gestor técnico" },
            { id: "608", value: "Toma de decisión - Director de área" },
            { id: "609", value: "Coordinación general técnica" },
            { id: "610", value: "Borrador de jurídico" },
            { id: "613", value: "Informe de jurídico" },
          ]
        } else if (response.data && response.data.accreditation_type_id != 1) {
          this.listReturn = [
            { id: "", value: this.$t("select_option") },
            { id: "600", value: "Otros procesos - Gestor técnico" },
            { id: "608", value: "Toma de decisión - Director área" },
            { id: "609", value: "Coordinación general técnica" },
            { id: "610", value: "Borrador de jurídico" },
            { id: "613", value: "Informe de jurídico" },
          ]
        }
      })
      .catch(({ error }) => {
          })
          .finally(() => {
            this.preloader = false;
          });
    },
    postReturnProcess() {
      if (!this.inputs.observations || !this.inputs.return_process ) {
        this.$toastr.e("Llenar los campos obligatorios");
        return;
      }
      this.preloader = true;
      this.inputs['accApp'] = this.$store.state.accreditation.id;
      const url = `/accreditationtechnical/return-processes/store`;
        axiosPost(url, this.inputs)
          .then(( res ) => {
            if (res.status == 200 && res.data.data == "OK") {
              this.$toastr.s(this.$t("updated_success"));
              this.returnPage();
            } else if(res.status == 200 && res.data.data == "noReturn"){
              this.$toastr.e(
              "El proceso ya se encuentra en ese estado"
            );
            } else {
              this.$toastr.e("Error");
            }
          })
          .catch(({ error }) => {
          })
          .finally(() => {
            this.preloader = false;
          });
    },
    returnPage() {
      window.location.href = "/";
    },
    openDeleteModal() {
      this.confirmationModalActive = true;
    },
    cancelled() {
      this.confirmationModalActive = false;
    },
  },
}
</script>

<style>

</style>